<div
	#mapContainer
	id="map"></div>
<div class="global-map-network-legend">
	<div class="legend-scale">
		<ul class="legend-labels">
			<li><span style="border-top: 6px solid #000000"></span>Cell C</li>
			<li><span style="border-top: 6px solid #f3db00"></span>MTN</li>
			<li><span style="border-top: 6px solid #166bce"></span>Telkom</li>
			<li><span style="border-top: 6px solid #eb1900"></span>Vodacom</li>
			<li><span style="border-top: 6px solid #666666"></span>Other</li>
		</ul>
	</div>
</div>
<app-chip-filter
	id="chip-filter"
	style="padding-top: 5px; width: 100%"
	[filterOptions]="filterOptions"
	(searchSubmit)="searchSubmit($event)"
	(filtersToggled)="filterToggled()"
	(filtersCleared)="filtersCleared()"
	(searchValueChanged)="searchValueChanged()">
</app-chip-filter>
@if (maploading == true) {
<div
	class="spin"
>
	<mat-spinner
		class="map-spinner"
		name="bubbles"></mat-spinner>
</div>
}

<div id="map-type-control">
	<div class="map-controls">
		<mat-list style="text-align: start; margin-left: 10px;">
			<h3 style="font-size: 13pt; font-weight: bold; text-align: center;">Map Options</h3>
			<mat-list-item>
				<button
					mat-button
					expand="block"
					[disabled]="circles.length == 0"
					(click)="clearCircles()"
					size="small"
					color="primary"
					fill="solid"
					>{{ circles.length == 0 ? "No Rings drawn" : "Clear Rings" }}</button
				>
			</mat-list-item>
			<mat-list-item>
				<mat-checkbox
					[disabled]="deviceMapData.length == 0"
					(ionChange)="toggleSelectionType()"
					color="dark"
					slot="start"></mat-checkbox>
				<mat-label>Select Multiple</mat-label>
			</mat-list-item>
			<mat-list-item>
				<mat-checkbox
					[disabled]="deviceMapData.length == 0"
					checked
					(ionChange)="toggleDeviceCluster()"
					color="dark"
					slot="start"></mat-checkbox>
				<mat-label>Show Clusters</mat-label>
			</mat-list-item>
			<mat-list-item>
				<mat-checkbox
					[disabled]="deviceMapData.length == 0"
					(ionChange)="
						showAllSignalStrength = !showAllSignalStrength; toggleAllSignalStrength(showAllSignalStrength)
					"
					color="dark"
					slot="start"></mat-checkbox>
				<mat-label>Show Signal Strength</mat-label>
			</mat-list-item>
			<mat-list-item>
				<mat-checkbox
					[disabled]="deviceMapData.length == 0"
					(ionChange)="showAllRingfence = !showAllRingfence; toggleAllRingfence(showAllRingfence)"
					color="dark"
					slot="start"></mat-checkbox>
				<mat-label>Show Ringfence</mat-label>
			</mat-list-item>
			<mat-list-item>
				<mat-checkbox
					[disabled]="maploading"
					(ionChange)="freezeMap = !freezeMap"
					color="dark"
					slot="start"></mat-checkbox>
				<mat-label>Freeze Map</mat-label>
			</mat-list-item>
			@if (aggregation) {
<mat-list-item>
				<mat-label>Clusters:</mat-label>&nbsp;
				<input
					matInput
					placeholder="1..15"
					type="number"
					(keyup.enter)="setMapRefresh(1)"
					(focusout)="setMapRefresh(1)"
					step="1"
					min="{{ minClusters }}"
					max="{{ maxClusters }}"
					(ionChange)="changeCluster($event)"
					name="numClusters"
					[value]="numClusters" />
			</mat-list-item>
}
		</mat-list>
		@if (!aggregation) {
<mat-list-item>
			<mat-label>{{ totalOffline }} Offline Devices</mat-label>
		</mat-list-item>
}
	</div>
</div>
